import { useState } from "react";
import { Icon, Badge } from './admin-ui';
import { ProductIcon } from './admin-ui/icons';

export function UpsellProductImage({ product }) {
  const [brokenSource, setBrokenSource] = useState("");
  const source = typeof product?.featured_image === "string" ? product.featured_image : "";
  return <span className="upsell-product-image" aria-hidden="true">
    {source && source !== brokenSource
      ? <img src={source} alt="" loading="lazy" onError={() => setBrokenSource(source)} />
      : <Icon source={ProductIcon} tone="subdued" />}
  </span>;
}

export function UpsellProductStatus({ product }) {
  if (!product) return <Badge tone="attention">Unavailable</Badge>;
  if (product.status == null) return null;
  return Number(product.status) === 1 ? <Badge tone="success">Active</Badge> : <Badge tone="attention">Not active</Badge>;
}

export default function UpsellProduct({ product, fallback, detail }) {
  return <span className="upsell-product">
    <UpsellProductImage product={product} />
    <span className="upsell-product-copy">
      <strong>{product?.title || fallback || "Unavailable product"}</strong>
      <span className="upsell-muted">{detail ?? (product
        ? (product.total_inventory != null ? `Inventory: ${product.total_inventory}` : product.handle || "")
        : "Sync products or remove this selection.")}</span>
    </span>
  </span>;
}
